var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('span',{staticClass:"current-progress",style:({width:_vm.setProgress + '%'})},[_vm._v(_vm._s(_vm.setProgress)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }